// Shared HTML sanitizer for content that is rendered with dangerouslySetInnerHTML.
// Added as a security fix: markdown and stored HTML written in the admin area (or
// produced by the blog automation) is now stripped of scripts, event handlers and
// javascript: URLs before it is inserted into the page.

import DOMPurify from 'dompurify';

const OPTIONS = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: ['target', 'rel', 'allow', 'allowfullscreen', 'frameborder', 'loading'],
  FORBID_TAGS: ['style', 'form', 'input', 'button', 'textarea', 'select', 'object', 'embed'],
  FORBID_ATTR: ['srcdoc', 'formaction', 'onerror', 'onload'],
};

export function sanitizeHtml(html: string | null | undefined): string {
  if (!html) return '';
  return DOMPurify.sanitize(String(html), OPTIONS) as unknown as string;
}
